// hooks/useError.ts
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';


const TOAST_ID = "error-toast"; // 🔹 one toast for all errors

const useError = (excludedStatus: (number | string)[] = []) => {
    const { t } = useTranslation(['common']);
    const showError = useCallback((error: any, customKeys?: { [key: string]: string }) => {
        const errorKeys: { [key: string]: string } = {
            "FETCH_ERROR": "network",
            "400": "bad_request",
            "401": "unauthorized",
            "403": "permissions",
            "404": "not_found",
            "500": "server",
            ...customKeys
        };
        if ('status' in error) {
            if (!excludedStatus.includes(error.status)) {
                const message = t(`errors.${errorKeys[error.status] || "server"}`);
                // 🔹 update existing toast if active
                if (toast.isActive(TOAST_ID)) {
                    toast.update(TOAST_ID, {
                        render: message,
                        type: "error",
                        autoClose: 3000,
                    });
                } else {
                    toast.error(message, { toastId: TOAST_ID, autoClose: 3000 });
                }
            }
        }
    }, []);

    return { showError };
};

export default useError;
